/** @jsxImportSource @emotion/react */
import React from 'react'
import { Box, Button, useTheme } from '@mui/material'
import { NavLink, useLocation } from 'react-router-dom'
import { navButtonStyle } from './WorkspaceNavbar.styles'

type TabKey = 'create' | 'saved'

interface WorkspaceNavbarProps {
  currentTab: TabKey
}

const RISK_BASE = '/app/risk/explorer/workspaces'
const LIVE_BASE = '/app/live/workspaces'

export const WorkspaceNavbar: React.FC<WorkspaceNavbarProps> = ({ currentTab }) => {
  const theme = useTheme()
  const { pathname } = useLocation()
  const base = pathname.startsWith('/app/live') ? LIVE_BASE : RISK_BASE
  const TABS: Array<{ key: TabKey; label: string; to: string }> = [
    { key: 'create', label: 'Create', to: `${base}/create` },
    { key: 'saved', label: 'Saved', to: `${base}/saved` },
  ]

  return (
    <Box
      css={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        gap: 8,
        padding: '8px 0',
        backgroundColor: theme.palette.grey[50],
      }}
      role="tablist"
      onClick={(e) => e.stopPropagation()}
    >
      {TABS.map(({ key, label, to }) => {
        const isActive = currentTab === key

        return (
          <Button
            key={key}
            component={NavLink}
            to={to}
            onClick={(e) => e.stopPropagation()}
            role="tab"
            aria-selected={isActive}
            variant="contained"
            css={navButtonStyle(theme, isActive, 'light', 6)}
          >
            {label}
          </Button>
        )
      })}
    </Box>
  )
}
